module.exports = __webpack_public_path__ + "img/kovy@3x.cd56da74.png";